import { ISupportRequest } from '@models/supportAccess/supportAccess.types';

/** «1:42» — сколько осталось до `deadline` (мс по часам клиента); не меньше нуля, без срока — пусто. */
export function formatRequestCountdown(deadline: number | null, now: number): string {
    if (deadline === null) return '';
    const left = Math.max(0, Math.ceil((deadline - now) / 1000));
    if (!Number.isFinite(left)) return '';
    const minutes = Math.floor(left / 60);
    const seconds = left % 60;
    return `${minutes}:${String(seconds).padStart(2, '0')}`;
}

/** Главная (жирная) часть плашки запроса. */
export function supportRequestTitle(request: ISupportRequest): string {
    const actor = request.actorName || 'Сотрудник поддержки';
    if (request.kind === 'invite') return `${actor} просит показать экран`;
    return request.durationMinutes
        ? `${actor} просит доступ к вашей учётной записи на ${request.durationMinutes} мин`
        : `${actor} просит доступ к вашей учётной записи`;
}

/** Приглашение к показу (§40): что увидит сотрудник. */
export const SUPPORT_INVITE_PRIVACY_TEXT = 'сотрудник увидит только эту вкладку, видео не записывается';

/** Продолжение после «·»: обращение и причина; у приглашения — что увидит сотрудник. */
export function supportRequestDetails(request: ISupportRequest): string {
    const parts: string[] = [];
    if (request.ticketRef) parts.push(`обращение ${request.ticketRef}`);
    if (request.kind === 'consent' && request.reason) parts.push(`причина: ${request.reason}`);
    if (request.kind === 'invite') parts.push(SUPPORT_INVITE_PRIVACY_TEXT);
    return parts.join(' · ');
}
